export const environmentRoutePaths = {
  HOME: '/environment',
  ENVIRONMENTAL_REPORT: '/environment/environmental-report',
  RECOVERY_AND_DISPOSAL: '/environment/recovery-and-disposal',
} as const;
